import { BANNER_TOAST_MESSAGES_SHOWED } from './constants';

export const wasToastShowed = (toastName = '') => {
  const sessionStorageToastMessages = sessionStorage.getItem(
    BANNER_TOAST_MESSAGES_SHOWED
  );
  if (sessionStorageToastMessages && sessionStorageToastMessages === 'true') {
    sessionStorage.removeItem(BANNER_TOAST_MESSAGES_SHOWED);
  } else if (sessionStorageToastMessages) {
    const showedToasts = JSON.parse(sessionStorageToastMessages);

    return showedToasts.includes(toastName);
  }
  return false;
};

export const setShowedToast = (toastName = '') => {
  let showedToasts = [];
  const sessionStorageToastMessages = sessionStorage.getItem(
    BANNER_TOAST_MESSAGES_SHOWED
  );
  if (sessionStorageToastMessages && sessionStorageToastMessages === 'true') {
    sessionStorage.removeItem(BANNER_TOAST_MESSAGES_SHOWED);
  } else if (sessionStorageToastMessages) {
    showedToasts = JSON.parse(sessionStorageToastMessages);
  }

  if (!showedToasts.includes(toastName)) {
    sessionStorage.setItem(
      BANNER_TOAST_MESSAGES_SHOWED,
      JSON.stringify([...showedToasts, toastName])
    );
  }
};
